(function () {
    'use strict';

    var app = angular.module('app', [
        // Angular modules 
        'ngAnimate',                // animations
        'ngRoute',                  // routing
        'ngSanitize',               // sanitizes html bindings (ex: sidebar.js)
        'ngMessages',               // Validation Messages
        'ngFileUpload',			    // Upload di Files
        'angularFileUpload',        // Upload di Files https://github.com/nervgh/angular-file-upload/wiki/Module-API
		'angularMoment',            // work with date
		'imageCropper',				// Image Cropper (angular-image-cropper.js)
        'ngFileUpload',               // ng-file-upload

        // Custom modules 
        'common',                   // common functions, logger, spinner
        'common.bootstrap',         // bootstrap dialog wrapper functions

        // 3rd Party Modules
        'ui.bootstrap',             // ui-bootstrap (ex: carousel, pagination, dialog)
		'ui.sortable',			    // sort item
		//'dialogs',	            // finestre di Dialogo (dialogs.min.js)
        'infinite-scroll',          // infinite scroll
        'googlechart',               // Google charts
        'pascalprecht.translate',     //angular translate
        'tmh.dynamicLocale',        //angular-dynamic-locale
        'localytics.directives'     //angular-chosen
    ]);

    // Lodash library
    app.factory('_', ['$window',
          function ($window) {
              // place lodash include before angular
              return $window._;
          }
    ]);
  
    // Handle routing errors and success events
    app.run(['$route', '$location', '$rootScope', 'datacontext', 'amMoment', function ($route, $location, $rootScope, datacontext, amMoment) {
        // Include $route to kick start the router.    

        $rootScope.filterKeydown = function(event, vm) {
            if(event.keyCode==13) vm.cerca(); 
        }

        $rootScope.exportAll = function(sTableName, sType, sEscape, sFontSize, sSheetName) {
            var ua = window.navigator.userAgent;
            var trident = ua.indexOf("Trident");
            var msie = ua.indexOf("MSIE ");

            if (msie > 0 || trident > 0) {
                var table = $(sTableName);
                var strCopy = $('<div></div>').html(table.clone()).html(); window.clipboardData.setData("Text", strCopy);

                var objExcel = new ActiveXObject("Excel.Application");
                objExcel.visible = false;
                var objWorkbook = objExcel.Workbooks.Add;
                var objWorksheet = objWorkbook.Worksheets(1);
                objWorksheet.Paste;
                objExcel.visible = true;
            }
            else {
                if (sType == 'pdf')
                    $(sTableName).tableExport({ type: sType, pdfFontSize: sFontSize, escape: sEscape, sheetName: sSheetName });
                else
                    $(sTableName).tableExport({ type: sType, escape: sEscape });
            }

            amMoment.changeLocale('it');
        }

        $rootScope.detectIE = function () {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // IE 12 => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }
    }]);

    app.service('sectionMenu', function ($rootScope) {
    	var section = '';

    	var setSection = function (area) {
    		return section = area;
    	};

    	var getSection = function () {
    		return section;
    	};

    	var isSectionActive = function (area) {
    		return section == area;
    	};

        var getClassIfActive = function (area) {
            return (section == area) ? 'activated ' + $rootScope.stile : ''; //area == vm.title, dell'area in questione
    	};    	

    	return {
    		setSection: setSection,
    		getSection: getSection,
    		isSectionActive: isSectionActive,
    		getClassIfActive: getClassIfActive
    	}
    });
})();
